import { render, staticRenderFns } from "./PortfolioList.vue?vue&type=template&id=9cf10018&scoped=true&"
import script from "./PortfolioList.vue?vue&type=script&lang=js&"
export * from "./PortfolioList.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioList.vue?vue&type=style&index=0&id=9cf10018&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf10018",
  null
  
)

export default component.exports